import { PublicClientApplication } from "@azure/msal-browser";
import { MSAL_CONFIG, USE_LOGGER } from './config/constants';

// Only log in development/qa environments
if (USE_LOGGER) {
  console.log("MSAL config", MSAL_CONFIG);
}

export const msalInstance = new PublicClientApplication(MSAL_CONFIG);

export const loginRequest = {
  scopes: ["openid", "profile", "User.Read"], 
  prompt: "select_account" // Force account selection
};

export const tokenRequest = {
  scopes: ["openid", "profile", "User.Read"],
  account: null, // Will be set dynamically
};
